module.exports = __webpack_public_path__ + "static/media/bf.a6dec3ee.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bf.svg
// module id = 867
// module chunks = 0